import React, {useState, useEffect} from "react"
import Header from "./header";
import Footer from "./footer";
import PopupForm from "./popupForm";
import "../css/sharan-style.css";
import "../css/style.css";
import "../css/animate.min.css";
import "../css/responsive.css";
import "../css/bootstrap.min.css";
import "../css/swiper-bundle.min.css";
import { Helmet } from "react-helmet";
import { graphql, useStaticQuery } from "gatsby";


const Layout = ( {children}) => {

  const [time, setTime] = useState(9000000000000)

  const query = useStaticQuery(graphql`
    {
        footerIcons: allFile(filter: {relativeDirectory: {eq: "footer"}}) {
            edges {
                node {
                    id
                    base
                    childImageSharp {
                        fixed (width: 30) {
                            ...GatsbyImageSharpFixed
                        }
                    }
                }
            }
        }
    }
  `)

  console.log('jello', query.footerIcons)

  useEffect(() => {
    setTime(9000000000000)
  }, [])

  const handlePopupWindow = () => {
    setTime(Math.random())
  }

  return (
    <div style={{fontFamily: "caros", overflowX: "hidden"}}>
      <Helmet>
        <link 
          rel="icon" 
          href="https://media.publit.io/file/TheWorldgrad/HeaderCommon/twg_favicon_ymgrbw.png" 
        />
      </Helmet>
      <Header/>
      <PopupForm time={time} />
      {children}
      <div className="col-12">
        <button 
          className="btn fixed-enquire-button" 
          onClick={handlePopupWindow}
        >
          Speak to an expert
        </button>
      </div>
      <Footer iconsArr={query.footerIcons} />
    </div>
  )
}

export default Layout;